<template>
  <div>

    <div v-if="this.showPolicy == false" >
     <div class="leng">
      <span @click="changeLeng('en')">EN</span>
      <span @click="changeLeng('it')">IT</span>
      <span @click="changeLeng('hr')">HR</span>
      <span @click="changeLeng('ro')">RO</span>
      <span @click="changeLeng('es')">ES</span>
      </div>


      <div class="section cc-store-home-wrap">
        <div class="intro-header">
          <div class="intro-content cc-homepage">
            <div class="intro-text">
              <div class="heading-jumbo">{{ $t("page.title") }}</div>
              <div class="paragraph-bigger cc-bigger-white-light">
                {{ $t("page.subtitle") }}
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="motto-wrap">
            <div class="heading-jumbo-small">{{ $t("page.title2") }}<br></div>
            <div class="div-block-6"></div>
          </div>
          <div class="home-content-wrap">
            <div class="w-form">
              <form id="email-form" name="email-form" data-name="Email Form" class="form">
                <div class="div-block">
                  <div class="div-block-3">
                    <label for="name-3" class="field-label-2">{{ $t("page.uniqueid") }}</label>
                      <input type="text" class="text-field-3 w-input" maxlength="256" name="email-2" data-name="Email 2" id="email-2" v-model="uniqueid">
                  </div>
                  <div class="div-block-2">
                    <label for="name">{{ $t("page.name") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name" data-name="Name" id="name" v-model="name">
                  </div>
                  <div class="div-block-2">
                    <label for="surname" class="field-label-2">{{ $t("page.surname") }}</label>
                    <input type="text" class="text-field-3 w-input" maxlength="256" name="surname" data-name="Surname" id="surname" v-model="surname">
                  </div>

                </div>
                <div class="div-block" style="margin-left:20px">
                  <div class="div-block-3" style="padding:10px">
                    <label for="email-3" class="field-label-3">{{ $t("page.datebirth") }}</label>
                    <div class="input-icons">
                      <i class="icon">
                        <img src="images/calendar.png" style="width:23px; position:absolute; z-index: 100; left:-22px;top:6px; display: inline" />
                      </i>
                      <datepicker :language="languages[this.leng]" class="text-field-4 input-field datepickerinput" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="birthdate"></datepicker>
                    </div>
                  </div>
                  <div class="div-block-3" style="padding:10px">
                    <label for="date" class="field-label-2">{{ $t("page.datecertificate") }}</label>
                    <div class="input-icons">
                      <i class="icon">
                        <img src="images/calendar.png" style="width:23px; position:absolute; z-index: 100; left:-22px;top:6px; display: inline" />
                      </i>
                      <datepicker :language="languages[this.leng]" class="text-field-4 input-field datepickerinput" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="date"></datepicker>
                    </div>
                  </div>
                </div>
                <div class="div-block-genere" style="overflow-x:auto;">
                  <div class="div-block-15">
                    <label for="email-2" class="field-label" style="padding-right:10px">{{ $t("page.gender") }}</label><label class="w-checkbox checkbox-field">
                      <input type="radio" id="female" name="female" value="female" data-name="Checkbox 3" class="w-checkbox-input" v-model="gender">
                      <span class="w-form-label">{{ $t("page.female") }}</span>
                    </label>
                    <label class="w-checkbox checkbox-field">
                      <input type="radio" id="male" name="male" value="male" data-name="Checkbox" class="w-checkbox-input" v-model="gender">
                      <span class="w-form-label">{{ $t("page.male") }}</span>
                    </label>
                  </div>

                </div>
                <div class="div-block-6"></div>
                <div class="div-block" v-for="item of caregivers" v-bind:key="item.id">
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.caregiversname") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="item.caregiversname">
                  </div>
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.caregiversemail") }}</label>
                    <input type="email" class="text-field-3 w-input" maxlength="256" name="email-2" data-name="Email 2" id="email-2" v-model="item.caregiversemail">
                  </div>
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.caregiversphone") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="item.caregiversphone">
                  </div>
                </div>
                <div>
                  <span style="border:0;margin-left:10px">
                    <input type="button" v-bind:value="$t('page.add_row')" class="submit-button w-button" @click="addRow('caregivers')">
                  </span>
                  <span style="border:0;margin-left:10px">
                    <input type="button" v-bind:value="$t('page.remove_row')" style="background: orange;" class="submit-button w-button" @click="removeRow('caregivers')">
                  </span>
                </div>

                <div class="div-block-6"></div>
                <div class="div-block">
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.pediatricname") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="pediatricname">
                  </div>
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.pediatricemail") }}</label>
                    <input type="email" class="text-field-3 w-input" maxlength="256" name="email-2" data-name="Email 2" id="email-2" v-model="pediatricemail">
                  </div>
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.pediatricphone") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="pediatricphone">
                  </div>
                </div>
                <div class="div-block-6"></div>
                <div class="div-block">
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.specialistname") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="specialistname">
                  </div>
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.specialistinstitution") }}</label>
                    <input type="text" class="text-field-3 w-input" maxlength="256" name="email-3" data-name="Email 3" id="email-3" v-model="specialistinstitution">
                  </div>
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.specialistemail") }}</label>
                    <input type="email" class="text-field-3 w-input" maxlength="256" name="email-2" data-name="Email 2" id="email-2" v-model="specialistemail">
                  </div>
                </div>
                <div class="div-block">
                  <div class="div-block-3">
                    <label for="email-4" class="field-label-3">{{ $t("page.specialistphone") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="specialistphone">
                  </div>
                </div>
                <div class="div-block-6"></div>
                <div class="div-block">
                  <div class="div-block-3" style="width: 100%">
                    <label for="email-4" class="field-label-3 bold">{{ $t("page.diseasename") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="diseasename">
                  </div>
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2">
                      <img src="images/info-xxl.png" style="width:25px; margin-left:5px; display: inline" />
                      {{ $t("page.diseasesummary") }}
                    </label>
                    <p>
                      <span>{{this.diseasesummary1}}</span>
                      <a v-bind:href="this.diseasesummary2link" target="_blank">{{this.diseasesummary2link}}</a>
                      <span>{{this.diseasesummary3}}</span>
                    </p>
                  </div>
                </div>
                <div class="div-block">
                  <div class="div-block-2">
                    <label for="email-4" class="field-label-3 bold">{{ $t("page.patientwight") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="patientweight">
                  </div>
                  <div class="div-block-2">
                    <label for="email-4" class="field-label-3 bold">{{ $t("page.patientheight") }}</label>
                    <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="patientheight">
                  </div>
                </div>

                <div class="div-block-4">
                    <label for="name-3" class="field-label-2 bold">{{ $t("page.generalindication") }}</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="diseasesummarynote"></textarea>
                </div>

                <div class="div-block-genere" style="margin-top:30px; overflow-x:auto">
                  <div class="div-block-15"><label for="email-2" class="field-label bold">{{ $t("page.behaviour") }}</label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Agitation" data-name="Checkbox 3" class="w-checkbox-input" v-model="agitation"><span class="w-form-label">{{ $t("page.Agitation") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Opposition" data-name="Checkbox" class="w-checkbox-input" v-model="opposition"><span class="w-form-label">{{ $t("page.Opposition") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Restless" data-name="Checkbox" class="w-checkbox-input" v-model="restless"><span class="w-form-label">{{ $t("page.Restless") }}</span></label>
                  </div>
                </div>
                <div class="div-block-genere" style="margin-top:30px; overflow-x:auto">
                  <div class="div-block-15"><label for="email-2" class="field-label bold">{{ $t("page.Communication") }}</label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Expressive" data-name="Checkbox 3" class="w-checkbox-input" v-model="expressive"><span class="w-form-label">{{ $t("page.Expressive") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Comprehensive" data-name="Checkbox" class="w-checkbox-input" v-model="comprehensive"><span class="w-form-label">{{ $t("page.Comprehensive") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Verbal" data-name="Checkbox" class="w-checkbox-input" v-model="verbal"><span class="w-form-label">{{ $t("page.Verbal") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Non Verbal" data-name="Checkbox" class="w-checkbox-input" v-model="nonverbal"><span class="w-form-label">{{ $t("page.NonVerbal") }}</span></label>
                  </div>
                </div>
                <div class="div-block-genere" style="margin-top:30px; overflow-x:auto">
                  <div class="div-block-15"><label for="email-2" class="field-label bold">{{ $t("page.Motorskills") }}</label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Walking" data-name="Checkbox 3" class="w-checkbox-input" v-model="walking"><span class="w-form-label">{{ $t("page.Walking") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Not walking" data-name="Checkbox" class="w-checkbox-input" v-model="notwalking"><span class="w-form-label">{{ $t("page.Notwalking") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Need for wheel chair" data-name="Checkbox" class="w-checkbox-input" v-model="needforwheel"><span class="w-form-label">{{ $t("page.Needforwheelchair") }}</span></label>
                  </div>
                </div>
                <div class="div-block-6"></div>
                <label class="field-label-3 bold">{{ $t("page.seizures") }}</label>
                <div class="div-block" style="overflow-x:auto;">
                    <table>
                      <tr>
                        <th></th>
                        <th>{{ $t("page.types") }}</th>
                        <th>{{ $t("page.frequency") }}</th>
                        <th>{{ $t("page.triggerfactor") }}</th>
                        <th>{{ $t("page.averageduration") }}</th>
                      </tr>
                      <tr v-for="item of seizures" v-bind:key="item.id">
                        <td style="width: 5px; text-align:center">{{item.id}}</td>
                        <!-- <td><textarea maxlength="5000" id="field-4" name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.types"></textarea></td> -->
                        <td>
                          <select  class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.types">
                            <option value="" >{{  optionsSelectTypesSeizure.seleziona }}</option>
                            <option v-bind:value= optionsSelectTypesSeizure.convulsivageneralizzata >{{ optionsSelectTypesSeizure.convulsivageneralizzata }}</option>
                            <option v-bind:value= optionsSelectTypesSeizure.convulsivaunilaterale >{{ optionsSelectTypesSeizure.convulsivaunilaterale }}</option>
                            <option v-bind:value= optionsSelectTypesSeizure.focale >{{ optionsSelectTypesSeizure.focale }}</option>
                            <option v-bind:value= optionsSelectTypesSeizure.miocloniemassive >{{ optionsSelectTypesSeizure.miocloniemassive }}</option>
                            <option v-bind:value= optionsSelectTypesSeizure.assenze >{{ optionsSelectTypesSeizure.assenze }}</option>
                          </select>
                          <!-- <textarea  maxlength="5000" id="field-4" name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.types"></textarea> -->
                        </td>
                        <td><textarea  maxlength="5000" id="field-4" name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.frequency"></textarea></td>
                        <td><textarea  maxlength="5000" id="field-4" name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.trigger"></textarea></td>
                        <td><textarea  maxlength="5000" id="field-4" name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.averageduration"></textarea></td>
                      </tr>
                      <tr>
                        <td style="border:0">
                          <input type="button" v-bind:value="$t('page.add_row')" class="submit-button w-button" @click="addRow('seizures')">
                        </td>
                        <td style="border:0;">
                          <input type="button" v-bind:value="$t('page.remove_row')" class="submit-button w-button" style="background: orange;" @click="removeRow('seizures')">
                        </td>
                      </tr>
                    </table>
                </div>

                <div class="div-block-6"></div>
                <div class="div-block-genere" style="overflow-x:auto;">
                  <div class="div-block-15"><label for="email-2" class="field-label bold">{{ $t("page.triggerfactors") }}</label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Fever" data-name="Checkbox 3" class="w-checkbox-input" v-model="fever"><span class="w-form-label">{{ $t("page.fever") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Heat" data-name="Checkbox" class="w-checkbox-input" v-model="heat"><span class="w-form-label">{{ $t("page.heat") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Intense physical activity" data-name="Checkbox 3" class="w-checkbox-input" v-model="intensephysicalactivity"><span class="w-form-label">{{ $t("page.intensephysicalactivity") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Patterns" data-name="Checkbox 3" class="w-checkbox-input" v-model="patterns"><span class="w-form-label">{{ $t("page.patterns") }}</span></label>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Light" data-name="Checkbox" class="w-checkbox-input" v-model="light"><span class="w-form-label">{{ $t("page.light") }}</span></label>
                    <br>
                    <label class="w-checkbox checkbox-field"><input type="checkbox" value="Other" data-name="Checkbox" class="w-checkbox-input" v-model="othercheck"><span class="w-form-label">{{ $t("page.other") }}</span></label>
                    <input v-if="this.othercheck == true" type="text" style="margin-left:10px" class="text-field-4 w-input" maxlength="256" name="other-2" data-name="Other 2" id="name-2" v-model="other">
                  </div>
                </div>
                <div class="div-block-6"></div>

                <div class="div-block-4">
                  <label for="name-3" class="field-label-2 bold">{{ $t("page.allergies") }}</label>
                  <textarea style="height:150px" maxlength="5000" class="text-field-4 w-input note" v-model="allergies"></textarea>
                </div>
                <div class="div-block-4">
                  <label for="name-3" class="field-label-2 bold">{{ $t("page.knowside") }}</label>
                  <textarea style="height:150px" maxlength="5000" class="text-field-4 w-input note" v-model="sideeffect"></textarea>
                </div>

                <div class="div-block">
                  <div class="div-block-2">
                    <label for="name-3" class="field-label-2 bold">
                      <img src="images/info-xxl.png" style="width:25px; margin-left:5px; display: inline" />
                      {{ $t("page.drugsinteraction") }}
                    </label>
                    <p>{{this.drugsinteractions}}</p>
                  </div>
                </div>

                <div class="div-block-6"></div>
                <label class="field-label-3 bold">
                  <img src="images/info-xxl.png" style="width:25px; margin-left:5px; display: inline" />
                  {{ $t("page.Treatments") }}
                </label>
                <p>
                  {{ $t('pdf.notetreatmentsintro') }}
                  <ul>
                    <li>{{ $t('pdf.notetreatments') }}</li>
                    <li>{{this.$t('pdf.trat1')}}</li>
                    <li>{{this.$t('pdf.trat2')}}</li>
                    <li>{{this.$t('pdf.trat2b')}}</li>
                    <li>{{this.$t('pdf.trat2c')}}</li>
                    <li>{{this.$t('pdf.trat3')}}</li>
                  </ul>
                </p>
                <div class="div-block" style="overflow-x:auto;">
                    <table >
                      <tr>
                        <th></th>
                        <th>{{ $t("page.drugsname") }}</th>
                        <th>{{ $t("page.Genericname") }}</th>
                        <th>{{ $t("page.Dose") }}</th>
                        <th>{{ $t("page.Datestarttreatment") }}</th>
                        <th>{{ $t("page.AdministrationWay") }}</th>
                        <th>{{ $t("page.AlternativeAdiministration") }}</th>
                      </tr>
                      <tr v-for="item of treatments" v-bind:key="item.id">
                        <td style="width: 5px; text-align:center">{{item.id}}</td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.name"></textarea></td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.genericname"></textarea></td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.dose"></textarea></td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.datestart"></textarea></td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.administrationway"></textarea></td>
                        <td><textarea  maxlength="5000"  name="field-4" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="item.alternativeadiministration"></textarea></td>
                      </tr>
                      <tr>
                        <td style="border:0">
                          <input type="button" v-bind:value="$t('page.add_row')" class="submit-button w-button" @click="addRow('treatments')">

                        </td>
                        <td style="border:0">
                          <input type="button" v-bind:value="$t('page.remove_row')" class="submit-button w-button"  style="background: orange;" @click="removeRow('treatments')">
                        </td>
                      </tr>
                    </table>
                </div>
                <div class="div-block-6"></div>
                <div class="div-block">
                  <div class="div-block-4" style='background-color:#eee; text-align: center;'>
                    <strong class="bold-text">
                      <h3 class="bold">{{ $t("page.titleadaptprotocol") }}</h3>
                      <p>{{ $t("page.titleadaptprotocol2") }}</p>
                      <br>
                      <p style="text-transform: uppercase;">{{ $t("page.generalindication") }}</p>
                      <p >{{ $t("page.fevertitle") }}</p>
                      <p >{{ $t("page.fever1") }}</p>
                      <p >{{ $t("page.fever2") }}</p>
                    </strong>
                  </div>
                </div>
                <div>
                  <div class="div-block-6"></div>
                  <p>
                    <span><img src="images/info-xxl.png" style="width:25px; margin-right:5px; display: inline" />
                      <span class="bold">{{ $t('page.statusemergencytratinfo') }}</span>
                      <a v-bind:href="$t('page.statusemergencytratlink')" target='_blank'>[{{ $t('page.statusemergencytratlink') }}]</a>
                    </span>
                  </p>
                  <br>
                  <table><tr><th><strong>{{ $t('page.statusemergencytrat') }}</strong></th></tr></table>
                  <table>
                    <tr>
                      <th style="background-color: #eee"></th>
                      <th style="background-color: #eee"><img src="images/info-xxl.png" style="width:25px; margin-right:5px; display: inline" />{{ $t("page.durationseizures") }}</th>
                      <th style="background-color: #eee"><img src="images/info-xxl.png" style="width:25px; margin-right:5px; display: inline" />{{ $t("page.drugkg") }}</th>
                      <th>{{ $t("page.fillinthe") }}</th>
                    </tr>
                    <tr >
                      <td style="font-size: 16px;line-height: 20px;text-align: center; border-bottom: 0px; background-color: #eee">
                        <div style="position: relative; top: 100px">
                          <p class="bold">{{ $t("page.PrePage") }}</p>
                        </div>
                      </td>
                      <td style="text-align: center; ; background-color: #eee">M 3-5 (***)</td>
                      <td style="text-align: center; ; background-color: #eee;width:200px;">{{ $t(this.emergencyepilection.a1) }}</td>
                      <td>
                        <textarea style="text-align: center;height: 170px;" maxlength="5000" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="emergencyepilection.a2"></textarea>
                      </td>
                    </tr>
                    <tr >
                      <td style="text-align: center;border:  0px;border-left: 1px solid #ddd; background-color: #eee"></td>
                      <td style="text-align: center; width:100px; background-color: #eee">M 10-15</td>
                      <td style="text-align: center; ; background-color: #eee;width:200px;">{{ $t(this.emergencyepilection.b1) }}</td>
                      <td><textarea style="text-align: center;height: 170px;" maxlength="5000" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="emergencyepilection.b2"></textarea></td>
                    </tr>
                    <tr >
                      <td style="font-size: 16px;line-height: 20px;text-align: center; width: 20%; padding:5px; border-bottom: 0px; background-color: #eee">
                      </td>
                      <td style="text-align: center; width:100px; background-color: #eee">M 30</td>
                      <td style="text-align: center; ; background-color: #eee;width:200px;">{{ $t(this.emergencyepilection.c1) }}</td>
                      <td><textarea style="text-align: center;height: 170px;" maxlength="5000" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="emergencyepilection.c2"></textarea></td>
                    </tr>
                    <tr >
                      <td style="text-align: center; width: 20%; padding:5px;border:  0px;border-left: 1px solid #ddd; background-color: #eee">
                        <div class="inpage">
                          <p class="bold">  {{ $t("page.InPage") }}</p>
                        </div>
                      </td>
                      <td style="text-align: center; width:100px; background-color: #eee">M 40-60</td>
                      <td style="text-align: center; ; background-color: #eee;width:200px;">{{ $t(this.emergencyepilection.d1) }}</td>
                      <td><textarea style="text-align: center;height: 170px;" maxlength="5000" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="emergencyepilection.d2"></textarea></td>
                    </tr>
                    <tr >
                      <td style="text-align: center; width: 20%; padding:5px;border:  0px;border-left: 1px solid #ddd;border-bottom: 1px solid #ddd; background-color: #eee"></td>
                      <td style="text-align: center; width:100px; background-color: #eee">M 60</td>
                      <td style="text-align: center; ; background-color: #eee;width:200px;">{{ $t(this.emergencyepilection.e1) }}</td>
                      <td><textarea style="text-align: center;height: 170px;" maxlength="5000" class="w-node-76e8eff158e1-ef9446c6 w-input" v-model="emergencyepilection.e2"></textarea></td>
                    </tr>
                    <tr >
                      <td style="font-weight: bold; padding:5px; border: 0px; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; background-color: #eee" colspan="4">
                        {{ $t("page.prehospital") }}
                      </td>
                    </tr>
                    <tr >
                      <td style="font-weight: bold; padding:5px; border: 0px; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; background-color: #eee" colspan="4">
                        {{ $t('page.Preinfo') }}
                      </td>
                    </tr>
                    <tr >
                      <td style="font-weight: bold; padding:5px; border: 0px; border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; background-color: #eee" colspan="4">
                          {{ $t('page.m35info') }}
                      </td>
                    </tr>
                  </table>
                </div>
                <div>
                  <div class="div-block-6"></div>
                  <div class="div-block">
                    <div class="div-block-3">
                      <label for="email-4" class="field-label-3 bold">{{ $t('page.statusemergencytrat3') }}</label>
                      <input type="text" class="text-field-4 w-input" maxlength="256" name="name-2" data-name="Name 2" id="name-2" v-model="statusemergencytrat1">
                      <span style="opacity:0.5">{{ $t('page.statusemergencytrat1example') }}</span>
                    </div>
                    <div class="div-block-4">
                      <label for="email-4" class="field-label-3">{{ $t('page.generalindication') }} :</label>
                      <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input" v-model="statusemergencytrat2"></textarea>
                    </div>
                  </div>
                </div>
                  <div class="div-block-6"></div>

                <div class="div-block-2">
                    <label for="name-3" class="field-label-2 bold ">{{ $t("page.statusemergencytratsalvavita") }} :</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="statusemergencytratsalvavitanote"></textarea>
                </div>


                <div class="div-block-2">
                    <label for="name-3" class="field-label-2 bold ">{{ $t("page.statusemergencytratsalvavita1") }} :</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="statusemergencytratsalvavitanote1"></textarea>
                </div>


                <div class="div-block-2">
                    <label for="name-3" class="field-label-2 bold ">{{ $t("page.othergeneralindication") }} :</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="feveradaptprotocolnote"></textarea>
                </div>

                <div class="div-block-6"></div>
                <p>{{this.$t('page.Add')}}</p>
                <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.generalindication") }}</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="addnote"></textarea>
                </div>
                <div class="div-block-6"></div>

                <p>
                  {{this.$t('page.Important')}}<br>
                  <img src="images/info-xxl.png" style="width:25px; margin-right:5px; display: inline" />{{this.$t('page.imp1')}}<br>
                  <img src="images/info-xxl.png" style="width:25px; margin-right:5px; display: inline" />{{this.$t('page.imp2')}}
                </p>
                <div class="div-block-2">
                    <label for="name-3" class="field-label-2">{{ $t("page.generalindicationPatient") }}</label>
                    <textarea  maxlength="5000" style="height:150px" class="text-field-4 w-input note" v-model="importantnote"></textarea>
                </div>
                <div class="div-block-6"></div>
                <div class="div-block-7">
                  <p>{{ $t('page.descfinal') }}</p>
                </div>
                <input style="margin: 5px; background-color: red; font-weight:bold" type="button" v-bind:value="this.$t('page.generate_pdf') +' in PDF'" data-wait="Please wait..." class="submit-button w-button" @click="generatePdf()">
                <input style="font-weight:bold" type="button" v-bind:value="this.$t('page.generate_docx') +' in DOCX'" data-wait="Please wait..." class="submit-button w-button" @click="generateDocx()">
              </form>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div id='popup' v-if="this.showPolicy">
      <div v-if="this.leng == 'it'">
        <img src="images/epicare.png" alt="Logo EpiCare" />
        <h3>DRAVET EMERGENCY PROTOCOL</h3>

        <p>
          Il <strong>Protocollo di Emergenza per la Sindrome di Dravet</strong> “Emergency Protocol” è un iniziativa che
          mette a disposizione dei pazienti affetti da questa sindrome rara, informazioni sullo stato generale
          del paziente ed un protocollo accurato di utilizzo personalizzato di farmaci in caso di emergenza ed
          in caso di accesso al Pronto soccorso.
        </p>
        <p>
          Una scheda che raccoglie dati e informazioni utili al processo di valutazione e alla definizione del codice di
          priorità in caso di ricovero di una persona con Sindrome di Dravet  che ha portato alla predisposizione di uno
          strumento denominato <strong>“Dravet Emergency Protocol”</strong>, in aiuto dei pazienti e destinato al personale medico e
          infermieristico di emergenza.
        </p>
        <p>
          Il progetto è stato coordinato da Isabella Brambilla (Dravet Italia Onlus) e dalla professoressa Rima Nabbout
          e con il contributo del SAB (Scientific Advisory Board) della DSEF-Dravet Syndrome European Federation
          (Prof. Cross, Prof. Dalla Bernardina, Prof. Guerrini, Prof. Lagae, Prof. Nabbout, Dr. Gil-Nagel Rein,
          Dr. Mingorance) e dei rappresentanti della DSEF (Myra De Groot, Renate Heusser, Simona Borroni, Galia Wilson).
          Il progetto è stato validato dal ERN EpiCARE.
        </p>
        <p>
          La scheda rileva, tra gli altri, oltre ai dati anagrafici del paziente, anche elementi che riguardano la diagnosi,
          il piano terapeutico, le condizioni generali di linguaggio e mobilità e la sintesi dei bisogni essenziali del
          paziente con malattia rara.
        </p>
        <p>
          Si tratta di uno strumento utile per far sì che ogni paziente possa esprimere le proprie specifiche
          esigenze e i trattamenti di cui necessita per ottimizzare il processo di presa in carico.
        </p>
        <p>
          <strong>DRAVET EMERGENCY PROTOCOL</strong> è disponibile sul sito EpiCARE, nella sezione <a class='inline' href="https://emergencyprotocol.epi-care.eu">emergencyprotocol.epi-care.eu</a>.
          E’ un’applicazione web che dà la possibilità di utilizzarlo sia compilando il format on-line, che scaricando
          il format in Word o PDF.
        </p>
        <p>
          Grazie a questa scheda è possibile migliorare la qualità e la tempestività della gestione in urgenza
          dei pazienti affetti da Malattia rara come la Sindrome di Dravet  ed è importante che venga compilata
          in ogni sua parte e tenuta sempre con sé in caso di necessità".
        </p>
        <p>
          Questo strumento permette di gestire al meglio le criticità, attraverso una sempre maggiore conoscenza
          e consapevolezza delle patologie, ed una corretta gestione personalizzata, considerata la rarità della
          patologia e la diversa e personale risposta ai farmaci per arrestare le diverse forme di crisi epilettiche
          o stato di male.
        </p>
        <p>
          Lo strumento permette al personale e agli operatori del Sistema sanitario di operare supportati da un
          documento del medico specialista, che indica strumenti pratici e sostenibili da mettere in atto prontamente,
          specialmente per queste malattie rare.
        </p>
        <h4>Tipologia di Dati Raccolti</h4>
        <p>
          Questo sito non utilizza alcun Cookie né altri strumenti di tracciamento.
        </p>
        <p>
          I dati inseriti nel form presente in questo sito non sono in alcun modo memorizzati da  EpiCARE/Dravet Italia Onlus né da terze parti.
        <br/>
          I dati vengono utilizzati solo per la generazione live di un documento (pdf o docx) senza che siano salvati (anche temporaneamente) su un database o altri supporti.
        </p>
        <p>
          L'Utente solleva EpiCARE/Dravet Italia Onlus da qualsiasi controversia dovuta all'uso dei documenti (e dei dati in essi contenuti) generati tramite questo sito e si assume altresì la responsabilità dei Dati Personali di terzi garantendo di avere il diritto di comunicarli o diffonderli, liberando il Titolare da qualsiasi responsabilità verso terzi.
        </p>
        <h4>Modalità e luogo del trattamento dei Dati raccolti</h4>
        <p>
          Il Titolare adotta le opportune misure di sicurezza volte ad impedire l’accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali.
          Il trattamento viene effettuato mediante strumenti informatici e/o telematici, con modalità organizzative e con logiche strettamente correlate alle finalità indicate.
        </p>
        <h4>Periodo di conservazione</h4>
        <p>
          I dati trattati non vengono conservati o memorizzati in alcun modo né dal sistema né dal Titolare del Trattamento.
        </p>
        <h4>Finalità del Trattamento dei Dati raccolti</h4>
        <p>
          I dati dell’Utente sono raccolti solo ed esclusivamente per consentire al Titolare di fornire il Servizio, senza che questi siano poi conservati in alcun modo.
        </p>

        <button @click="setShowPolicy()">Accetta</button>
      </div>
      <div v-if="this.leng == 'hr'">
        <img src="images/epicare.png" alt="Logo EpiCare" />
        <h3>PROTOKOL ZA HITNA STANJA ZA SINDROM DRAVET</h3>
        <p>
          <strong>Protokol za hitna stanja za sindrom Dravet</strong>
          je inicijativa koja pruža oboljelima od ovog rijetkog sindroma informacije
          o općem zdravstvenom stanju oboljelog i ispravan protokol za personalizirano
          korištenje lijekova u slučaju hitnih situacija i odlaska na hitnu pomoć.
        </p>
        <p>
        Obrazac koji prikuplja podatke i informacije korisne za procjenu procesa i definiranje prioriteta
        u slučaju hospitalizacije osobe oboljele od sindroma Dravet, doveo je do stvaranja alata,
        nazvanog <strong>"Protokol za hitna stanja za sindrom Dravet"</strong>, kako bi pomogao oboljelima
        i namijenjen je osoblju koje pruža hitnu pomoć tj. liječnicima i medicinskim sestrama hitne pomoći.
        </p>
        <p>
        Projekt su koordinirale Isabella Brambilla (Dravet Italia Onlus) i prof.
        Rima Nabbout uz doprinos Znanstvenog odbora Dravet Sindrom Europske Federacije (DSEF)
        (prof. Cross, prof. Dalla Bernardina, prof. Lagae, dr. Gil-Nagel Rein, dr. Mingorance)
        i predstavnici DSEF-a (Myra De Groot, Renata Heusser, Simona Borroni, Galia Wilson).
        ERN EpiCARE je validirao ovaj projekt.
        </p>
        <p>
        Uz osobne podatke oboljelog, obrazac uključuje i informacije o dijagnozi, planu liječenja, govornom
        izražavanju i mobilnosti te sažetak esencijalnih potreba oboljelog s rijetkom bolesti.
        </p>
        <p>
        Ovo je koristan alat koji pomaže svakom oboljelom za naglašavanje njihovih specifičnih potreba i
        potrebne terapije kako bi se usavršio proces liječničke skrbi.
        </p>
        <p>
        <strong>DRAVET PROTOKOL ZA HITNA STANJA</strong> je dostupan na web stranici ERN EpiCARE-a,
        na sljedećoj poveznici: <a class='inline' href="https://emergencyprotocol.epi-care.eu">emergencyprotocol.epi-care.eu.</a>
        Ovo je web obrazac koji se može ispuniti online ili offline te preuzeti u Word ili PDF dokumentu.
        </p>
        <p>
        Zahvaljujući ovom dokumentu možemo poboljšati kvalitetu i brzinu liječenja hitnih situacija kod oboljelih
        od rijetkih bolesti poput sindroma Dravet. Stoga je važno da je svaki dio obrasca ispunjen i da ga
        oboljeli ima sa sobom u slučaju potrebe.
        </p>
        <p>
        Ovaj alat omogućuje bolje upravljanje kritičnim poteškoćama tako da povećava znanje i svijest o
        bolesti te pruža prikladno personalizirano liječenje uzimajući u obzir rijetkost bolesti i različit
        individualni odgovor oboljelog na liječenje različitih vrsta epileptičnih napadaja i epileptičnog
        statusa antikonvulzivnim lijekovima.
        </p>
        <p>
        Alat omogućuje i pružateljima zdravstvene skrbi da obavljaju svoje dužnosti uz podršku dokumenta
        kojeg su pripremili specijalisti što ukazuje na to da je alat praktičan i održiv te se može brzo
        koristiti za ovu rijetku bolest.
        </p>
        <h4>Vrsta prikupljenih podataka</h4>
        <p>
        Ova stranica ne koristi kolačiće niti druge alate praćenja.
        </p>
        <p>
        Podatke koji se upisuju u obrazac, ERN EpiCARE/Dravet Italia Onlus ili treća strana ne pohranjuje
        ni na koji način. Podaci se koriste za izravnu pripremu dokumenta (pdf ili docx) bez mogućnosti
        spremanja (čak ni privremenog) u bazu podataka ili druge medije.
        </p>
        <p>
        Korisnik oslobađa ERN EpiCARE/Dravet Italia Onlus od bilo kakvog spora koji proizlazi iz korištenja
        dokumenata pripremljenih putem ove web stranice (i podataka sadržanih na njima) te također preuzima
        odgovornost za osobne podatke trećih strana, jamčeći da ih ima pravo priopćiti ili dijeliti,
        oslobađajući voditelja obrade podataka bilo kakve odgovornosti prema trećim stranama.
        </p>
        <h4>Načini i mjesto obrade podataka</h4>
        <p>
        Vlasnik usvaja odgovarajuće sigurnosne mjere za sprječavanje neovlaštenog pristupa, otkrivanja, izmjene ili uništavanja osobnih podataka.
        </p>
        <p>
        Obrada se provodi pomoću računalnih i/ili telematičkih alata s organizacijskim metodama i logistikom koja je strogo povezana s navedenim svrhama.
        </p>
        <h4>Razdoblje očuvanja podataka</h4>
        <p>
        Obrađeni podaci se ne čuvaju ni pohranjuju ni na koji način, ni od strane sustava ni od strane voditelja obrade podataka.
        </p>
        <h4>Svrhe obrade podataka</h4>
        <p>
        Podaci korisnika se prikupljaju samo i isključivo kako bi voditelju obrade podataka omogućili pružanje usluge, bez pohranjivanja ni na koji način.
        </p>
        <button @click="setShowPolicy()">Prihvatiti</button>
      </div>
      <div v-if="this.leng == 'ro'">
        <img src="images/epicare.png" alt="Logo EpiCare" />
        <h3>PROTOCOL DE URGENȚĂ DRAVET</h3>

        <p>
          <strong>Protocolul de urgență pentru sindromul Dravet</strong> este o inițiativă care oferă
          pacienților care suferă de acest sindrom rar informații despre starea generală a pacientului
          și un protocol precis pentru utilizarea personalizată a medicației în caz de urgență și în
          cazul prezentării la camera de gardă.
        </p>
        <p>
          Un formular care colectează date și informații utile pentru procesul de evaluare și definirea
          codului de prioritate în cazul internării în spital a unei persoane cu Sindromul Dravet a dus
          la elaborarea unui instrument numit <strong>"Protocolul de urgență Dravet"</strong> pentru a
          veni în ajutorul pacienților, destinat însă personalului medical de urgență și de asistență medicală.
        </p>
        <p>
          Proiectul a fost coordonat de Isabella Brambilla (Dravet Italia Onlus) și de profesoara Rima Nabbout, cu contribuția Consiliului științific consultativ (Scientific Advisory Board) al DSEF (Federația Europeană pentru Sindromul Dravet (Prof. Cross, Prof. Dalla Bernardina, Prof. Guerrini, Prof. Lagae, Prof. Nabbout, Dr. Gil-Nagel Rein, Dr. Mingorance) și a reprezentanților DSEF (Myra De Groot, Renata Heusser, Simona Borroni, Galia Wilson). Proiectul a fost validat de către ERN EpiCARE.
        </p>
        <p>
          Pe lângă datele personale ale pacientului, protocolul include, de asemenea, elemente privind diagnosticul, planul de tratament, condițiile generale de vorbire și mobilitate și un rezumat al nevoilor esențiale ale pacientului cu această boală rară.
        </p>
        <p>
          Este un instrument util pentru ca nevoile specifice și tratamentele necesare fiecărui pacient să fie exprimate, pentru a optimiza procesul de asistență medicală.
        </p>
        <p>
          <strong>PROTOCOLUL DE URGENȚĂ DRAVET</strong> este disponibil pe site-ul EpiCARE, în secțiunea emergencyprotocol.epi-care.eu. Este un formular care poate fi completat on-line sau off-line prin descărcarea acestuia în format Word sau PDF.
        </p>
        <p>
          Formularul permite îmbunătățirea calității și a rapidității gestionării în regim de urgență a pacienților ce suferă de boli rare cum este sindromul Dravet și este important ca fiecare câmp să fie completat și disponibil în permanență în caz de urgență.
        </p>
        <p>
          Acest instrument permite o mai bună gestionare a aspectelor critice, prin intermediul unei cunoașteri și conștientizări sporite a bolii, precum și un management personalizat adecvat, având în vedere raritatea bolii și răspunsul personal diferit la medicamentele antiepileptice pentru diferite tipuri de crize sau status epilepticus.
        </p>
        <p>
          De asemenea, protocolul permite furnizorilor de asistență medicală să opereze cu sprijinul unui document furnizat de un medic specialist, care indică instrumente practice și durabile care pot fi utilizate prompt, în special pentru aceste boli rare.
        </p>
        <h4>Tipul de date colectate</h4>
        <p>
        Acest site nu utilizează cookie-uri sau alte instrumente de urmărire.
        </p>
        <p>
        Datele introduse în formular nu sunt stocate în niciun fel de EpiCARE/Dravet Italia Onlus sau de terțe părți. Datele sunt folosite doar pentru generarea imediată a unui document (pdf sau docx), fără a fi salvate (chiar și temporar) într-o bază de date sau pe alt suport.
        </p>
        <p>
        Utilizatorul exonerează EpiCARE/Dravet Italia Onlus de orice litigiu rezultat din utilizarea documentelor generate prin intermediul acestui site (și a datelor conținute în acestea) și își asumă, de asemenea, responsabilitatea pentru datele personale ale terților, garantând că are dreptul de a le comunica sau difuza, exonerând Operatorul de date de orice responsabilitate față de terți.
        </p>
        <h4>Metode și locul de prelucrare a datelor</h4>
        <p>
        Titularul adoptă măsuri de securitate adecvate pentru a preveni accesul neautorizat, divulgarea, modificarea sau distrugerea datelor cu caracter personal.
        </p>
        <p>
        Prelucrarea se realizează prin intermediul unor instrumente informatice și/sau telematice, cu metode de organizare și logice strict legate de scopurile indicate.
        </p>
        <h4>Perioada de păstrare</h4>
        <p>
        Datele prelucrate nu sunt păstrate sau stocate în niciun fel, nici de către sistem, nici de către Operator.
        </p>
        <h4>Scopurile prelucrării datelor</h4>
        <p>
        Datele Utilizatorului sunt colectate numai și exclusiv pentru a permite Operatorului de date să furnizeze Serviciul, fără a fi stocate în vreun fel.
        </p>

        <button @click="setShowPolicy()">Acceptă</button>
      </div>
      <div v-if="this.leng == 'es'">
        <img src="images/epicare.png" alt="Logo EpiCare" />
        <h3>PROTOCOLO DE EMERGENCIA DRAVET</h3>

        <p>
          El <strong>Protocolo de Emergencia para el Síndrome de Dravet</strong>, es una iniciativa que proporciona a
          los pacientes que padecen este raro síndrome, información sobre el estado general del paciente y un protocolo
          preciso para el uso personalizado de la medicación en caso de urgencia y en caso de ingreso en urgencias.
        </p>
        <p>
          Un formulario que recoge datos e información útil para el proceso de evaluación y definición del código de prioridad
          en caso de ingreso en un hospital de una persona con Síndrome de Dravet, dando lugar a la elaboración de una herramienta
          denominada <strong>Protocolo de Emergencia Dravet</strong> para ayudar a los pacientes y está destinado al médico personal y
          de enfermería de urgencias.
        </p>
        <p>
          El proyecto fue coordinado por Isabella Brambilla (Dravet Italia Onlus) y la profesora Rima Nabbout con la contribución del SAB (Scientific Advisory Board) de la Federación Europea del Síndrome de Dravet-DSEF (Prof. Cross, Prof. Dalla Bernardina, Prof. Guerrini , Prof. Lagae, Prof. Nabbout, Dr. Gil-Nagel Rein, Dr. Mingorance) y representantes de DSEF (Myra De Groot, Renata Heusser, Simona Borroni, Galia Wilson). El proyecto fue validado por EpiCARE ERN.
        </p>
        <p>
          Además de los datos personales del paciente, la tarjeta también incluye elementos relativos al diagnóstico, el plan de tratamiento, las condiciones generales del habla y la movilidad y un resumen de las necesidades esenciales del paciente con una enfermedad rara.
        </p>
        <p>
          Es una herramienta útil para ayudar a cada paciente a expresar sus necesidades específicas y los tratamientos requeridos para optimizar el proceso asistencial.
        </p>
        <p>
          El <strong>PROTOCOLO DE EMERGENCIA DRAVET</strong> está disponible en el sitio web de EpiCARE, en la sección emergenciaprotocol.epi-care.eu. Es un formulario web que se puede completar en línea o fuera de línea descargándolo en un archivo Word o PDF.
        </p>
        <p>
          Gracias a este formulario, es posible mejorar la calidad y rapidez de la gestión de urgencias de pacientes que padecen enfermedades raras como el Síndrome de Dravet. Es importante que todos los campos estén cumplimentados y actualizados en todo momento en caso de emergencia.
        </p>
        <p>
          Esta herramienta permite una mejor gestión de cuestiones críticas, mediante un mayor conocimiento y conciencia de la enfermedad, y un manejo adecuado personalizado, considerando la rareza de la enfermedad y la diferente respuesta personal a los fármacos antiepilépticos sobre los diferentes tipos de crisis o estatus epiléptico.
        </p>
        <p>
          La herramienta permite a los proveedores de atención médica operar respaldados por un documento proporcionado por un médico especialista, que indica herramientas prácticas y sostenibles que pueden utilizarse rápidamente, especialmente para estas enfermedades raras
        </p>

        <h4>Tipo de datos recopilados</h4>
        <p>
          Este sitio no utiliza cookies ni otras herramientas de seguimiento.
        </p>
        <p>
          Los datos introducidos en el formulario no son almacenados de ningún modo por EpiCARE/Dravet Italia Onlus ni por terceros. Los datos se utilizan únicamente para la generación en vivo de un documento (pdf o docx) sin guardarlos (tampoco temporalmente) en una base de datos u otro medio.
        </p>
        <p>
          El Usuario libera a EpiCARE/ Dravet Italia Onlus de cualquier controversia derivada del uso de los documentos generados a través de este sitio web (y de los datos contenidos en el mismo) y también asume la responsabilidad por los Datos Personales de terceros, garantizando que tiene derecho a comunicarlos o difundirlos, liberando al Responsable del Tratamiento de cualquier responsabilidad frente a terceros.
        </p>
        <h4>Métodos y lugar del procesamiento de datos</h4>
        <p>
          El Titular adopta medidas de seguridad adecuadas para evitar el acceso no autorizado, divulgación, modificación o destrucción de Datos Personales.
        </p>
        <p>
          El tratamiento se realiza mediante herramientas informáticas y/o telemáticas, con métodos y lógicas organizativas estrictamente relacionadas con las finalidades indicadas.
        </p>
        <h4>Periodo de conservacion</h4>
        <p>
          Los datos procesados no son conservados ni almacenados de ninguna manera ni por el sistema ni por el Responsable del tratamiento.
        </p>
        <h4>Multas por procesamiento de datos</h4>
        <p>
        Los datos del Usuario se recogen única y exclusivamente para permitir al Responsable del Tratamiento la prestación del Servicio, sin ser almacenados de ningún modo.
        </p>

        <button @click="setShowPolicy()">Acepte</button>
      </div>
      <div v-if="(this.leng == 'en') || ((this.leng != 'it') && (this.leng != 'hr') && (this.leng != 'ro') && (this.leng != 'es'))">
          <img src="images/epicare.png" alt="Logo EpiCare" />
          <h3>DRAVET EMERGENCY PROTOCOL EN</h3>

          <p>
            The <strong>Emergency Protocol for Dravet Syndrome</strong> is an initiative that provides patients
            suffering from this rare syndrome with information on the general state of the patient and an accurate
            protocol for the personalized use of medication in case of an emergency and in case of access to the emergency room.
          </p>
          <p>
            A form that collects data and information useful for the assessment process and the definition of the priority code
            in case of admission to a Hospital of a person with Dravet Syndrome, which led to the drafting of a tool
            called <strong>"Dravet Emergency Protocol"</strong>, to help patients and intended for emergency medical and nursing staff.
          </p>
          <p>
            The project was coordinated by Isabella Brambilla (Dravet Italia Onlus) and Professor Rima Nabbout with the contribution
            of the SAB (Scientific Advisory Board), of the DSEF-Dravet Syndrome European Federation (Prof. Cross, Prof. Dalla Bernardina,
            Prof. Guerrini, Prof. Lagae, Prof. Nabbout, Dr. Gil-Nagel Rein, Dr. Mingorance) and representatives of DSEF (Myra De Groot,
            Renate Heusser, Simona Borroni, Galia Wilson). The project was validated by the EpiCARE ERN.
          </p>
          <p>
            In addition to the patient’s personal data, the card also includes elements concerning the diagnosis, the treatment plan, the general speech and mobility conditions and a summary of the essential needs of the patient with a rare disease.
          </p>
          <p>
            It is a useful tool for helping each patient express their specific needs and the treatments they require in order to optimize the health care process.
          </p>
          <p>
            The <strong>DRAVET EMERGENCY PROTOCOL</strong> is available on the EpiCARE website, in the section <a class='inline' href="https://emergencyprotocol.epi-care.eu">emergencyprotocol.epi-care.eu</a>. It is a web form that can be filled out on-line or off-line by downloading it in Word or PDF.
          </p>
          <p>
            Thanks to this form, it is possible to improve the quality and rapidity of the emergency management of patients suffering from rare diseases such as Dravet Syndrome and it is important that it is filled out in every part and kept with you at all times in case of need.
          </p>
          <p>
            This tool allows for better management of critical issues, by means of an increasing knowledge and awareness of the disease, and a proper personalized management, considering the rarity of the disease and the different personal response to antiepileptic drugs on the different types of seizures or epileptic status.
          </p>
          <p>
            The tool allows healthcare providers  to operate supported by a document supplied by a medica specialist, which indicates practical and sustainable tools that can be used promptly especially for these rare diseases”.
          </p>

          <h4>Type of Data Collected</h4>
          <p>
            This site does not use cookies or other tracking tools.
          </p>
          <p>
            The data entered in the form are not stored in any way by EpiCARE/Dravet Italia Onlus or third parties.
            The data are used only for the live generation of a document (pdf or docx) without being saved (even temporarily) on a database or other media.
          </p>
          <p>
            The User releases EpiCARE/ Dravet Italia Onlus from any dispute arising from the use of the documents generated through this website (and the data contained therein) and also assumes responsibility for the Personal Data of third parties, guaranteeing that he/she has the right to communicate or disseminate them, releasing the Data Controller from any liability towards third parties.
          </p>
          <h4>Methods and place of Data processing</h4>
          <p>
            The Owner adopts appropriate security measures to prevent unauthorized access, disclosure, modification or destruction of Personal Data.
          </p>
          <p>
            The processing is carried out by means of computer and/or telematic tools, with organizational methods and logics strictly related to the purposes indicated.
          </p>
          <h4>Period of conservation</h4>
          <p>
            The processed data are not kept or stored in any way either by the system or by the Data Controller.
          </p>
          <h4>Purposes of Data Processing</h4>
          <p>
          The User's data are collected solely and exclusively to allow the Data Controller to provide the Service, without being stored in any way.
          </p>

          <button @click="setShowPolicy()">Accept</button>
      </div>
    </div>
  </div>
</template>
<script>



//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////// SCRIPT DI PAGINA ////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

import { AlignmentType, Document, HeadingLevel, Media, Packer, Paragraph, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx";
import docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import JSZip from 'jszip';
import JSzipUtils from 'jszip-utils';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from "vuejs-datepicker/src/locale";
//import { font } from '../font.js';
//import { font } from '../Montserrat-normal.js';
import { fontBold } from '../Montserrat-Bold-bold.js';
import { font } from '../Montserrat-Regular-normal.js';

export default {
  components: {
    Datepicker
  },
  name: 'Certificate',
  data(){
    return{
      showPolicy: true,
      languages: lang,
      yes: '',
      datavalue1: '',
      datavalue2: '',
      leng: navigator.language.split("-")[0],
      date: '',
      name: '',
      surname: '',
      birthdate: '',
      gender: '',
      uniqueid: '',
      caregivers:[
        {
          id: 1,
          caregiversname: '',
          caregiversphone: '',
          caregiversemail: '',
        }
      ],
      nextcaregiversid: 2,
      pediatricname: '',
      pediatricphone: '',
      pediatricemail: '',
      specialistname: '',
      specialistinstitution: '',
      specialistphone: '',
      specialistemail: '',
      diseasename: '',
      diseasesummary1: '',
      diseasesummary2link: '',
      diseasesummary3: '',
      diseasesummarynote: '',
      /*trigger*/
      fever: false,
      heat: false,
      intensephysicalactivity: false,
      light: false,
      othercheck: false,
      other: '',
      patterns: false,
      /* */
      sideeffect: '',
      allergies: '',
      patientweight: '',
      patientheight: '',
      drugsinteractions: '',
      seizures: [
        {
          id: 1,
          types: '',
          frequency: '',
          trigger: '',
          averageduration: '',
        },
        {
          id: 2,
          types: '',
          frequency: '',
          trigger: '',
          averageduration: '',
        }
      ],
      nextseizuresid: 3,
      /*behaviour*/
      agitation: false,
      opposition: false,
      restless: false,
      /*communication*/
      expressive: false,
      comprehensive: false,
      verbal: false,
      nonverbal: false,
      /*motor skills*/
      walking: false,
      notwalking: false,
      needforwheel: false,
      treatments: [
        {
          id: 1,
          name: '',
          genericname: '',
          dose: '',
          datestart: '',
          administrationway: '',
          alternativeadiministration: ''
        }
      ],
      nexttreatmentsid: 2,
      feveradaptprotocol: '',
      feveradaptprotocolnote: '',
      importantnote: '',
      addnote: '',
      statusepilection: '',
      statusepilectionnote: '',
      emergencyepilection:  {
          a1: 'page.diazepam',
          a2: '',
          b1: 'page.zolam',
          b2: '',
          c1: 'page.clonazepam',
          c2: '',
          d1: 'page.valproic',
          d2: '',
          e1: 'page.agents',
          e2: ''
      },
      statusemergencyepilection: '',
      statusemergencytrat1: '',
      statusemergencytratsalvavita: '',
      statusemergencytratsalvavitanote: '',
      statusemergencytratsalvavita1: '',
      statusemergencytratsalvavitanote1: '',
      statusemergencytrat2: '',
      optionsSelectTypesSeizure: {
        seleziona: '' ,
        convulsivageneralizzata: '',
        convulsivaunilaterale: '',
        focale: '',
        miocloniemassive: '',
        assenze: '',
      }
    }
  },
  mounted() {
    this.loaddata();
  },
  methods: {
    setShowPolicy: function(){
      this.showPolicy = false;
      this.changeLeng(this.leng);
    },
    loaddata: function(){
      this.yes = this.$t('page.yes');
      this.datavalue1 = this.$t('page.datavalue1');
      this.datavalue2 = this.$t('page.datavalue2');
      this.diseasename = this.$t('page.valdiseasename');
      this.diseasesummary1 = this.$t('page.valdiseasesummary1');
      this.diseasesummary2link = this.$t('page.valdiseasesummary2link');
      this.diseasesummary3 = this.$t('page.valdiseasesummary3');
      this.drugsinteractions = this.$t('page.valdrugsinteractions');
      this.optionsSelectTypesSeizure = {
        seleziona: this.$t("page.seleziona") ,
        convulsivageneralizzata: this.$t('page.convulsivageneralizzata'),
        convulsivaunilaterale: this.$t('page.convulsivaunilaterale'),
        focale: this.$t('page.focale'),
        miocloniemassive: this.$t('page.miocloniemassive'),
        assenze: this.$t('page.assenze'),
      }
    },
    changeLeng: function(locale){
      this.leng = locale
      this.$i18n.locale = this.leng;
      this.loaddata();
    },
    addRow: function (item){
      if(item == 'caregivers'){
        this.caregivers.push({
          id: this.nextcaregiversid,
          caregiversname: '',
          caregiversphone: '',
          caregiversemail: '',
        })
        this.nextcaregiversid++
      }

      if(item == 'seizures'){
        this.seizures.push({
          id: this.nextseizuresid,
          types: '',
          frequency: '',
          trigger: '',
          averageduration: '',
        })
        this.nextseizuresid++
      }

      if(item == 'treatments'){
        this.treatments.push({
          id: this.nexttreatmentsid,
          name: '',
          genericname: '',
          dose: '',
          datestart: '',
          administrationway: '',
          alternativeadiministration: ''
        })
        this.nexttreatmentsid++
      }
    },
    removeRow: function (item){
      if(item == 'caregivers'){
        this.caregivers.splice(this.caregivers.length-1, 1);
        this.nextcaregiversid=this.nextcaregiversid-1
      }
      if(item == 'seizures'){
        this.seizures.splice(this.seizures.length-1, 1);
        this.nextseizuresid=this.nextseizuresid-1
      }
      if(item == 'treatments'){
        this.treatments.splice(this.treatments.length-1, 1);
        this.nexttreatmentsid=this.nexttreatmentsid-1
      }
    },

//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
////////////////////////////// GENERA DOCX ///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

    generateDocx: function(){
      // Create document
      const doc = new Document();
      let tables = []
      const icon = Media.addImage(doc, this.$t('pdf.iconbase64'), 15, 15)
           const image = Media.addImage(doc, this.$t('pdf.logobase64'), 220, 50, {
        floating: {
            horizontalPosition: {
                // offset: 3250000,
                offset: 1000000,
            },
            verticalPosition: {
                offset: 930000,
            },
            margins: {
                top: 50000,
                bottom: 50000,
            },
        }
      });

      tables.push(
          new Paragraph(image),
          new Paragraph({
              height: { size: 200, type: WidthType.DXA },
              alignment: AlignmentType.RIGHT,
              heading: HeadingLevel.HEADING_1,
              spacing: {
                  after: 200,
              },
              children: [
                new TextRun({
                    text: this.$t('pdf.title'),
                    bold: true,
                    thematicBreak: true,
                }),
              ],
          }),
          new Paragraph({heading: HeadingLevel.HEADING_1}),
       );

      tables.push(new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [2250,2250,2250,2250],
          rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Date')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ text: (this.date) ? moment(this.date).format('DD/MM/YYYY') : ''})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Unique')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ text: this.uniqueid })]})]}),
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Name')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.name)] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Surname')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.surname)] }), ],
              }),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Birthdate')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph((this.birthdate) ? moment(this.birthdate).format('DD/MM/YYYY') : '')] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Gender')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.gender)] }), ],
              }),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.SpecialistN')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.specialistname)] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.SpecialistI')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.specialistinstitution)] }), ],
              }),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.SpecialistP')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.specialistphone)] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.SpecialistE')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.specialistemail)] }), ],
              }),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.PediatricN')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.pediatricname)] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.PediatricP')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.pediatricphone)] }), ],
              }),
              new TableRow({ children: [
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.PediatricE')})]})]}),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.pediatricemail)] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [] }),
                new TableCell({ width: { size: 2250, type: WidthType.DXA },margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [] }), ],
              }),
          ],
      }))

      if(this.caregivers.length > 0){
        tables.push( new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [3000,3000,3000],
          rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.CaregiversN')})]})]}),
              new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.CaregiversP')})]})]}),
              new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.CaregiversE')})]})]}),
            ]}),
          ]
        }))

        for(let item of this.caregivers){
          tables.push( new Table({
            width: { size: 9000, type: WidthType.DXA },
            margins: {top: 0,bottom: 0},
            columnWidths: [3000,3000,3000],
            rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.caregiversname})]})]}),
                new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.caregiversphone})]})]}),
                new TableCell({ width: { size: 3000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.caregiversemail})]})]}),
              ]}),
            ]
          }))
        }
      }

      tables.push(new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [4500,4500],
          rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.DiseaseN')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.diseasename})]})]}),
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({ children: [icon, new TextRun({ bold: true, text: this.$t('pdf.DiseaseS')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.diseasesummary1+" "+this.diseasesummary2link+" "+this.diseasesummary3)] })
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({children: [new TextRun({ bold: true, text: this.$t('pdf.Patientw')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.patientweight)] }),
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({children: [new TextRun({ bold: true, text: this.$t('pdf.Patienth')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.patientheight)] }),
              ]}),

              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t("page.generalindication")+" :"})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.diseasesummarynote.replace(/\r?\n/g, '\n'))] })
              ]}),
          ],
      }))



      /* behaviour */
      let behaviours = []
      behaviours.push((this.agitation) ? " [X] "+this.$t('pdf.Agitation') : " [  ] "+this.$t('pdf.Agitation') )
      behaviours.push((this.opposition) ? " [X] "+this.$t('pdf.Opposition') : " [  ] "+this.$t('pdf.Opposition') )
      behaviours.push((this.restless) ? " [X] "+this.$t('pdf.Restless') : " [  ] "+this.$t('pdf.Restless') )

      /* communication */
      let communications = []
      communications.push((this.expressive) ? " [X] "+this.$t('pdf.Expressive') : " [  ] "+this.$t('pdf.Expressive') )
      communications.push((this.comprehensive) ? " [X] "+this.$t('pdf.Comprehensive') : " [  ] "+this.$t('pdf.Comprehensive') )
      communications.push((this.verbal) ? " [X] "+this.$t('pdf.Restless') : " [  ] "+this.$t('pdf.Restless') )
      communications.push((this.nonverbal) ? " [X] "+this.$t('pdf.NonVerbal') : " [  ] "+this.$t('pdf.NonVerbal') )

      /*motor skills*/
      let motorskills = []
      motorskills.push((this.walking) ? " [X] "+this.$t('pdf.Walking') : " [  ] "+this.$t('pdf.Walking') )
      motorskills.push((this.notwalking) ? " [X] "+this.$t('pdf.NotWalking') : " [  ] "+this.$t('pdf.NotWalking') )
      motorskills.push((this.needforwheel) ? " [X] "+this.$t('pdf.NeedChair') : " [  ] "+this.$t('pdf.NeedChair') )


      tables.push(new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [4500,4500],
          rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({children: [new TextRun({ bold: true, text: this.$t('pdf.Behaviours')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [
                  //new Paragraph({text: behaviours[0] + ' ' + behaviours[1] + ' ' + behaviours[2]}),
                  new Paragraph({text: behaviours[0]}),
                  new Paragraph({text: behaviours[1]}),
                  new Paragraph({text: behaviours[2]})
                ]})
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({children: [new TextRun({ bold: true, text: this.$t('pdf.Communication')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [
                  //new Paragraph({text: communications[0] + ' ' + communications[1] + ' ' + communications[2] + ' ' + communications[3]}),
                  new Paragraph({text: communications[0]}),
                  new Paragraph({text: communications[1]}),
                  new Paragraph({text: communications[2]}),
                  new Paragraph({text: communications[3]})
                ]})
              ]}),
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({children: [new TextRun({ bold: true, text: this.$t('pdf.Motor')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [
                  //new Paragraph({text: motorskills[0] + ' ' + motorskills[1] + ' ' + motorskills[2]}),
                  new Paragraph({text: motorskills[0]}),
                  new Paragraph({text: motorskills[1]}),
                  new Paragraph({text: motorskills[2]})
                ]})
              ]}),
          ],
      }))

      tables.push(new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [9000],
        rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.Seizures')})]})]}),
            ]}),
        ],
      }))

      tables.push( new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [2300,2220,2240,2240],
        rows: [
          new TableRow({ children: [
            new TableCell({ width: { size: 2300, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.Types')})]})]}),
            new TableCell({ width: { size: 2220, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.Frequency')})]})]}),
            new TableCell({ width: { size: 2240, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.Trigger')})]})]}),
            new TableCell({ width: { size: 2240, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t('pdf.Averageduration')})]})]}),
          ]}),
        ]
      }))

      for(let item of this.seizures){
        if(item.types || item.frequency || item.trigger || item.averageduration){
          tables.push( new Table({
            width: { size: 9000, type: WidthType.DXA },
            margins: {top: 0,bottom: 0},
            columnWidths: [2300,2220,2240,2240],
            rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 2300, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,
                children: [
                  new Paragraph({ text: item.types == this.$t('page.convulsivageneralizzata') ? " [X] "+this.$t('page.convulsivageneralizzata') : " [  ] "+this.$t('page.convulsivageneralizzata') }),
                  new Paragraph({ text: item.types == this.$t('page.convulsivaunilaterale') ? " [X] "+this.$t('page.convulsivaunilaterale') : " [  ] "+this.$t('page.convulsivaunilaterale') }),
                  new Paragraph({ text: item.types == this.$t('page.focale') ? " [X] "+this.$t('page.focale') : " [  ] "+this.$t('page.focale') }),
                  new Paragraph({ text: item.types == this.$t('page.miocloniemassive') ? " [X] "+this.$t('page.miocloniemassive') : " [  ] "+this.$t('page.miocloniemassive') }),
                  new Paragraph({ text: item.types == this.$t('page.assenze') ? " [X] "+this.$t('page.assenze') : " [  ] "+this.$t('page.assenze') }),
                ]}),
                new TableCell({ width: { size: 2220, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.frequency})]})]}),
                new TableCell({ width: { size: 2240, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.trigger})]})]}),
                new TableCell({ width: { size: 2240, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.averageduration})]})]}),
              ]}),
            ]
          }))
        }
      }


       /* trigger factors */
      let triggerfactors = []
      triggerfactors.push((this.fever) ? " [X] "+this.$t('pdf.FeverTrigger') : " [  ] "+this.$t('pdf.FeverTrigger') )
      triggerfactors.push((this.heat) ? " [X] "+this.$t('pdf.Heat') : " [  ] "+this.$t('pdf.Heat') )
      triggerfactors.push((this.intensephysicalactivity) ? " [X] "+this.$t('pdf.Intense') : " [  ] "+this.$t('pdf.Intense') )
      triggerfactors.push((this.light) ? " [X] "+this.$t('pdf.Light') : " [  ] "+this.$t('pdf.Light') )
      triggerfactors.push((this.patterns) ? " [X] "+this.$t('pdf.Patterns') : " [  ] "+this.$t('pdf.Patterns') )
      triggerfactors.push((this.othercheck) ? " [X] "+this.other : " [  ] "+this.$t('page.other') )

      tables.push(new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [4500,4500],
          rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Trigger')})]})]}),
                new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [
                  new Paragraph({text: triggerfactors[0]}),
                  new Paragraph({text: triggerfactors[1]}),
                  new Paragraph({text: triggerfactors[2]}),
                  new Paragraph({text: triggerfactors[3]}),
                  new Paragraph({text: triggerfactors[4]}),
                  new Paragraph({text: triggerfactors[5]}),
                ]})
              ]}),
          ],
      }))

      tables.push(new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [9000],
        rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: this.$t('pdf.Some')})]})]}),
            ]}),
        ],
      }))

      tables.push(new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [4500,4500],
        rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.KNOWNside1')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.sideeffect)] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.Allergies')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.allergies)] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({ children: [icon,new TextRun({ bold: true, text: this.$t('pdf.Drugs')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.drugsinteractions)] }),
            ]}),
        ],
      }))


      tables.push(new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [9000],
          rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [icon,new TextRun({ bold:true, text: this.$t('pdf.Treatments')})]})]}),
              ]}),
              new TableRow({ children: [ new TableCell({  width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"},children: [
                new Paragraph({text: this.$t('pdf.notetreatmentsintro')}),
                new Paragraph({text: this.$t('pdf.notetreatments'),bullet: {level: 0}}),
                new Paragraph({text: this.$t('pdf.trat1'),bullet: {level:  0}}),
                new Paragraph({text: this.$t('pdf.trat2'),bullet: {level:  0}}),
                new Paragraph({text: this.$t('pdf.trat2b'),bullet: {level: 0}}),
                new Paragraph({text: this.$t('pdf.trat2c'),bullet: {level: 0}}),
                new Paragraph({text: this.$t('pdf.trat3'),bullet: {level:  0}}),
              ] }), ]}),
          ],
      }))

      tables.push( new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [1500,1500,1500,1500,1500,1500],
        rows: [
          new TableRow({ children: [
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.drugsname") })]})]}),
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.Genericname")})]})]}),
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.Dose")})]})]}),
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.Datestarttreatment")})]})]}),
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.AdministrationWay")})]})]}),
            new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ bold: true, text: this.$t("page.AlternativeAdiministration")})]})]}),
          ]}),
        ]
      }))

      for(let item of this.treatments){
        if( item.name || item.genericname ||item.dose ||item.datestart ||item.administrationway ||item.alternativeadiministration){
          tables.push( new Table({
            width: { size: 9000, type: WidthType.DXA },
            margins: {top: 0,bottom: 0},
            columnWidths: [1500,1500,1500,1500,1500,1500],
            rows: [
              new TableRow({ children: [
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.name})]})]}),
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.genericname})]})]}),
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.dose})]})]}),
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.datestart})]})]}),
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.administrationway})]})]}),
                new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.alternativeadiministration})]})]}),

              ]}),
            ]
          }))
        }
      }

      tables.push( new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [9000],
        rows: [
          // new TableRow({ children: [new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.Emergency'))] })]}),
          new TableRow({ children: [new TableCell({ width: { size: 1500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [
            new Paragraph({alignment: AlignmentType.CENTER, heading: HeadingLevel.HEADING_1, children: [new TextRun({ text: this.$t('page.titleadaptprotocol')})]}),
            new Paragraph({alignment: AlignmentType.CENTER, heading: HeadingLevel.HEADING_1, children: [new TextRun({ text: this.$t('page.titleadaptprotocol2')})]}),
            new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ bold: true, text:this.$t("page.generalindication")+" :"})]}),
            new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ bold: true, text:this.$t("pdf.Fever")})]}),
            new Paragraph({ alignment: AlignmentType.CENTER, children: [ new TextRun({ bold: true, text:this.$t("page.fever1")})]}),
          ]}),]}),

          new TableRow({ children: [new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "ffffff"}, children: [new Paragraph("")] })]}),
          new TableRow({ children: [new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({children: [icon,new TextRun({ text: this.$t('page.statusemergencytratinfo') +" "+this.$t('page.statusemergencytratlink')})]})] })]}),
          new TableRow({ children: [new TableCell({ width: { size: 10500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, heading: HeadingLevel.HEADING_2, children: [new TextRun({ text: this.$t('pdf.STATUS2')})]})]}),             ]}),
         ]
      }));

      // if(this.statusepilection == 'si' || this.statusepilection == 'yes'){
        tables.push( new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [1000,1000,2500,4500],
          rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('')] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({children: [icon,new TextRun({ text: this.$t('pdf.Duration')})]})] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({children: [icon,new TextRun({ text: this.$t('pdf.Drugperkg')})]})] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph('')] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.Pre'))] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('M 3-5 (***)')] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t(this.emergencyepilection.a1))] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph(this.$t(this.emergencyepilection.a2))] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.Pre'))] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('M 10-15')] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t(this.emergencyepilection.b1))] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph(this.$t(this.emergencyepilection.b2))] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.In'))] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('M 30')] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t(this.emergencyepilection.c1))] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph(this.$t(this.emergencyepilection.c2))] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.In'))] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('M 45-60')] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t(this.emergencyepilection.d1))] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph(this.$t(this.emergencyepilection.d2))] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t('pdf.In'))] }),
              new TableCell({ width: { size: 1000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph('M 60')] }),
              new TableCell({ width: { size: 2500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph(this.$t(this.emergencyepilection.e1))] }),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,  children: [new Paragraph(this.$t(this.emergencyepilection.e2))] }),
            ]}),
          ]
        }))

        tables.push( new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [9000],
          rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.leg1')})]})] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.leg2')})]})] }),
            ]}),
            new TableRow({ children: [
              new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, shading: { fill: "eeeeee"}, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('pdf.leg3')})]})] }),
            ]}),
          ]
        }))
      // }

      // if(this.statusemergencyepilection == 'si' || this.statusemergencyepilection == 'yes'){
        tables.push( new Table({
          width: { size: 9000, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [2250,2250,2250,2250],
          rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 2250, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('page.statusemergencytrat3')})]})]}),
              new TableCell({ width: { size: 2250, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.statusemergencytrat1)] }),
              new TableCell({ width: { size: 2250, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('page.generalindication')})]})]}),
              new TableCell({ width: { size: 2250, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.statusemergencytrat2)] }),
            ]}),
          ]
        }))

        tables.push( new Table({
          width: { size: 4500, type: WidthType.DXA },
          margins: {top: 0,bottom: 0},
          columnWidths: [4500,4500],
          rows: [
            new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('page.statusemergencytratsalvavita')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.statusemergencytratsalvavitanote)] }),
            ]}),
             new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('page.statusemergencytratsalvavita1')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.statusemergencytratsalvavitanote1)] }),
            ]}),
             new TableRow({ children: [
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph({ children: [new TextRun({ bold: true, text: this.$t('page.othergeneralindication')})]})]}),
              new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.feveradaptprotocolnote)] }),
            ]}),
          ]
        }))
      // }

      tables.push( new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [9000],
        rows: [
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: this.$t('pdf.Add')})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "ffffff"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: this.$t("page.generalindication") +": " + this.addnote})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: this.$t('pdf.Important')})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [icon,new TextRun({text: this.$t('pdf.imp1')})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [icon,new TextRun({text: this.$t('pdf.imp2')})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "ffffff"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: this.$t("page.generalindicationPatient") +": " + this.importantnote})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "ffffff"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: ''})]})]}) ]}),
          new TableRow({ children: [ new TableCell({ width: { size: 9000, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER,shading: { fill: "eeeeee"}, children: [new Paragraph({alignment: AlignmentType.CENTER, children: [new TextRun({text: this.$t('pdf.finaldesc')})]})]}) ]}),
        ]
      }))

      tables.push( new Table({
        width: { size: 9000, type: WidthType.DXA },
        margins: {top: 0,bottom: 0},
        columnWidths: [4500,4500],
        rows: [
          new TableRow({ children: [
            new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 100,bottom: 100,left: 100,right: 100,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph('')] }) ,
            new TableCell({ width: { size: 4500, type: WidthType.DXA }, margins: {top: 500,bottom: 500,left: 500,right: 500,}, verticalAlign: VerticalAlign.CENTER, children: [new Paragraph(this.$t('pdf.signature'))] })
          ]}),
        ]
      }))

      doc.addSection({ children: tables });

      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, this.$t('pdf.namepdf') + '.docx')
      })
    },

////////////////////////////////
////////////////////////////////
//DOCX DA TEMPLATE SE NECESSARIO
    loadFile(url,callback){
        JSzipUtils.getBinaryContent(url,callback);
    },
    createDOC(){
        this.loadFile("/template.docx",function(error,content){
        var zip = new JSZip(content);
        var doc=new docxtemplater().loadZip(zip)
        doc.setData({
            test: 'John',
            last_name: 'Doe',
            phone: '0652455478',
            description: 'New Website'
        });
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }
        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        }) //Output the document using Data-URI
        saveAs(out,"output.docx")
        })
    },

//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
/////////////////////////////// GENERA PDF ///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////

    createData: function(){

      if(this.validate() == false){
        // alert(this.$t('page.alert'))
        // return false;
      }

      let title = this.$t('pdf.title');
      let namepdf = this.$t('pdf.namepdf');

      /* trigger factors */
      let triggerfactors = []
      triggerfactors.push((this.fever) ? " [X] "+this.$t('pdf.FeverTrigger') : " [  ] "+this.$t('pdf.FeverTrigger') )
      triggerfactors.push((this.heat) ? " [X] "+this.$t('pdf.Heat') : " [  ] "+this.$t('pdf.Heat') )
      triggerfactors.push((this.intensephysicalactivity) ? " [X] "+this.$t('pdf.Intense') : " [  ] "+this.$t('pdf.Intense') )
      triggerfactors.push((this.light) ? " [X] "+this.$t('pdf.Light') : " [  ] "+this.$t('pdf.Light') )
      triggerfactors.push((this.patterns) ? " [X] "+this.$t('pdf.Patterns') : " [  ] "+this.$t('pdf.Patterns') )
      triggerfactors.push((this.othercheck) ? " [X] "+this.other : " [  ] "+this.$t('page.other') )


      /* behaviour */
      let behaviours = []
      behaviours.push((this.agitation) ? " [X] "+this.$t('pdf.Agitation') : " [  ] "+this.$t('pdf.Agitation') )
      behaviours.push((this.opposition) ? " [X] "+this.$t('pdf.Opposition') : " [  ] "+this.$t('pdf.Opposition') )
      behaviours.push((this.restless) ? " [X] "+this.$t('pdf.Restless') : " [  ] "+this.$t('pdf.Restless') )

      /* communication */
      let communications = []
      communications.push((this.expressive) ? " [X] "+this.$t('pdf.Expressive') : " [  ] "+this.$t('pdf.Expressive') )
      communications.push((this.comprehensive) ? " [X] "+this.$t('pdf.Comprehensive') : " [  ] "+this.$t('pdf.Comprehensive') )
      communications.push((this.verbal) ? " [X] "+this.$t('pdf.Restless') : " [  ] "+this.$t('pdf.Restless') )
      communications.push((this.nonverbal) ? " [X] "+this.$t('pdf.NonVerbal') : " [  ] "+this.$t('pdf.NonVerbal') )

      /*motor skills*/
      let motorskills = []
      motorskills.push((this.walking) ? " [X] "+this.$t('pdf.Walking') : " [  ] "+this.$t('pdf.Walking') )
      motorskills.push((this.notwalking) ? " [X] "+this.$t('pdf.NotWalking') : " [  ] "+this.$t('pdf.NotWalking') )
      motorskills.push((this.needforwheel) ? " [X] "+this.$t('pdf.NeedChair') : " [  ] "+this.$t('pdf.NeedChair') )

      /* date */
      var datacertificato = (this.date) ? moment(this.date).format('DD/MM/YYYY') : '';
      var datanascita = (this.birthdate) ? moment(this.birthdate).format('DD/MM/YYYY') : '';

      let data1= [
        [this.$t('pdf.Date'), datacertificato, this.$t('pdf.Unique'), this.uniqueid],
        [this.$t('pdf.Name'), this.name,this.$t('pdf.Surname'), this.surname],
        [this.$t('pdf.Birthdate'), datanascita,this.$t('pdf.Gender'), this.gender],
        [this.$t('pdf.SpecialistN'), this.specialistname,this.$t('pdf.SpecialistI'), this.specialistinstitution],
        [this.$t('pdf.SpecialistP'), this.specialistphone, this.$t('pdf.SpecialistE'), this.specialistemail],
        [this.$t('pdf.PediatricN'), this.pediatricname, this.$t('pdf.PediatricP'), this.pediatricphone],
        [this.$t('pdf.PediatricE'), this.pediatricemail],
      ];

      let data2aheader= [];
      let data2a= [];

      if(this.caregivers.length > 0){
        data2aheader.push(
          [this.$t('pdf.CaregiversN'), this.$t('pdf.CaregiversP'), this.$t('pdf.CaregiversE')],
        );
      }
      for(let item of this.caregivers){
        data2a.push(
          [item.caregiversname, item.caregiversphone, item.caregiversemail],
        );
      }

      let data2b= [
        [this.$t('pdf.DiseaseN'), this.diseasename],
      ];
      let data2b1= [
        ["(¡)",this.$t('pdf.DiseaseS'), this.diseasesummary1+" "+this.diseasesummary2link+" "+this.diseasesummary3],
      ];

      let data2b2= [
        [this.$t('pdf.Patientw'), this.patientweight],
        [this.$t('pdf.Patienth'), this.patientheight],
        [this.$t('page.generalindication'), this.diseasesummarynote.replace(/\r?\n/g, '\n')],
      ];
      let data2c= [
        [this.$t('pdf.Trigger'), triggerfactors.toString().replace(/,/g, "\n")]
      ];
      let data3= [
        [this.$t('pdf.Some')],
      ];
      let data4= [
        [this.$t('pdf.KNOWNside1'), this.sideeffect],
        [this.$t('pdf.Allergies'), this.allergies],
      ];
      let data4b= [
        ["(¡)",this.$t('pdf.Drugs'), this.drugsinteractions]
      ];
      let data5= [
        [this.$t('pdf.Seizures')],
      ];
      let data6= [
        [this.$t('pdf.Types'),this.$t('pdf.Frequency'),this.$t('pdf.Trigger'),this.$t('pdf.Averageduration')]
      ];
      let data7 = [];



      for(let item of this.seizures){
        if(item.types || item.frequency || item.trigger || item.averageduration){
          let itemTypes = []
          itemTypes.push(item.types == this.$t('page.convulsivageneralizzata') ? " [X] "+this.$t('page.convulsivageneralizzata') : " [  ] "+this.$t('page.convulsivageneralizzata'))
          itemTypes.push(item.types == this.$t('page.convulsivaunilaterale') ? " [X] "+this.$t('page.convulsivaunilaterale') : " [  ] "+this.$t('page.convulsivaunilaterale'))
          itemTypes.push(item.types == this.$t('page.focale') ? " [X] "+this.$t('page.focale') : " [  ] "+this.$t('page.focale'))
          itemTypes.push(item.types == this.$t('page.miocloniemassive') ? " [X] "+this.$t('page.miocloniemassive') : " [  ] "+this.$t('page.miocloniemassive'))
          itemTypes.push(item.types == this.$t('page.assenze') ? " [X] "+this.$t('page.assenze') : " [  ] "+this.$t('page.assenze'))
          data7.push([itemTypes.toString().replace(/,/g, "\n"),item.frequency,item.trigger, item.averageduration]);
          //data7.push([item.types,item.frequency,item.trigger, item.averageduration]);
        }
      }

      let data8 = [
        [this.$t('pdf.Behaviours'), behaviours.toString().replace(/,/g, "\n")],
        [this.$t('pdf.Communication'), communications.toString().replace(/,/g, "\n")],
        [this.$t('pdf.Motor'), motorskills.toString().replace(/,/g, "\n")]

      ]

      let data9 = [["(¡)",this.$t('pdf.Treatments')]]
      let data10 = [[
        this.$t('pdf.notetreatmentsintro')+"\n"+
        '• '+this.$t('pdf.notetreatments')+"\n"+
        '• '+this.$t('pdf.trat1')+"\n"+
        '• '+this.$t('pdf.trat2')+"\n"+
        '• '+this.$t('pdf.trat2b')+"\n"+
        '• '+this.$t('pdf.trat2c')+"\n"+
        '• '+this.$t('pdf.trat3')
      ]];

       let data11= [
         [ this.$t('page.drugsname'),this.$t('page.Genericname'),this.$t('page.Dose'),this.$t('page.Datestarttreatment'),this.$t('page.AdministrationWay'),this.$t('page.AlternativeAdiministration')]
      ];
      let data12 = [];

      for(let item of this.treatments){
        if( item.name ||
          item.genericname ||
          item.dose ||
          item.datestart ||
          item.administrationway ||
          item.alternativeadiministration){
          data12.push([
            item.name ,
            item.genericname ,
            item.dose ,
            item.datestart ,
            item.administrationway ,
            item.alternativeadiministration
          ]);
        }
      }

      let data13 = [
        // [this.$t('pdf.Emergency')],
        [
          this.$t("page.titleadaptprotocol")+"\n"+
          this.$t("page.titleadaptprotocol2")+"\n"+
          this.$t("page.generalindication")+" :"+"\n"+
          this.$t('pdf.Fever')+"\n"+
          this.$t("page.fever1")
        ]
        // [this.$t("page.fever2")],
        // ["Note: " + this.feveradaptprotocolnote],
        // [this.$t('pdf.STATUS1') +": "+this.statusepilection],
      ];

      let data13space = [
        ['']
      ];

      let data13a = [
        ["(¡)",this.$t('page.statusemergencytratinfo')+" "+this.$t('page.statusemergencytratlink')],
      ];


      let data13c = [
        [this.$t('pdf.STATUS2')]
      ];

      let data14a = [
        ['(¡)',this.$t('pdf.Duration'),'(¡)',this.$t('pdf.Drugperkg'),''],
      ];
      let data14 = [
        [this.$t('pdf.Pre'),'M 3-5 (***)', this.$t(this.emergencyepilection.a1), this.$t(this.emergencyepilection.a2)],
        [this.$t('pdf.Pre'),'M 10-15', this.$t(this.emergencyepilection.b1), this.$t(this.emergencyepilection.b2)],
        [this.$t('pdf.In'),'M 30', this.$t(this.emergencyepilection.c1), this.$t(this.emergencyepilection.c2)],
        [this.$t('pdf.In'),'M 45-60', this.$t(this.emergencyepilection.d1), this.$t(this.emergencyepilection.d2)],
        [this.$t('pdf.In'),'M 60', this.$t(this.emergencyepilection.e1), this.$t(this.emergencyepilection.e2)],
      ];
      let data14b = [
        [this.$t('pdf.leg1')],
     ];

      let data14b1 = [
        [this.$t('pdf.leg2')],
     ];

      let data14b2 = [
        [this.$t('pdf.leg3')],
     ];

      let data15 = [
        //  [this.$t('pdf.STATUS3'), this.statusemergencyepilection, ''],
        [this.$t('page.statusemergencytrat3'), this.statusemergencytrat1, this.$t('page.generalindication')+":", this.statusemergencytrat2],
      ];

      let data15a = [
        [this.$t('page.statusemergencytratsalvavita'), this.statusemergencytratsalvavitanote],
        [this.$t('page.statusemergencytratsalvavita1'), this.statusemergencytratsalvavitanote1],
        [this.$t('page.othergeneralindication'), this.feveradaptprotocolnote],
      ];

      let data16a = [
        [this.$t('pdf.Add') ],
      ];
      let data16b = [
        [this.$t("page.generalindication") +": " + this.addnote],
      ];
      let data16c = [
        [this.$t('pdf.Important')],
      ];
      let data16d = [
        ["(¡) ",this.$t('pdf.imp1')],
        ["(¡) ",this.$t('pdf.imp2')],
      ];
      let data16e = [
        [this.$t("page.generalindicationPatient") +": " + this.importantnote],
      ];
      let data16f = [
        [''],
      ];
      let data16g = [
        [this.$t('pdf.finaldesc')],
      ];

      let data17 = [
        ['',this.$t('pdf.signature')],
      ];

      let datapdf = {
        title,
        namepdf,
        data1,
        data2aheader,
        data2a,
        data2b,
        data2b1,
        data2b2,
        data2c,
        data3,
        data4,
        data4b,
        data5,
        data6,
        data7,
        data8,
        data9,
        data10,
        data11,
        data12,
        data13,
        data13space,
        data13a,
        // data13b,
        data13c,
        data14a,
        data14b,
        data14b1,
        data14b2,
        data14,
        data15,
        data15a,
        data16a,
        data16b,
        data16c,
        data16d,
        data16e,
        data16f,
        data16g,
        data17
      }
      return datapdf;
    },
    generatePdf: function (){
      let datapdf = this.createData();
      if (datapdf){
        let pdfName = datapdf.namepdf;
        var img = this.$t('pdf.logobase64');

        let doc = new jsPDF('p', 'mm', 'a4');

        doc.addFileToVFS('Montserrat-Regular-normal.ttf', font);
        doc.addFont('Montserrat-Regular-normal.ttf', 'Montserrat-Regular', 'normal');
        doc.setFont("Montserrat-Regular");

        doc.addFileToVFS('Montserrat-Bold-bold.ttf', fontBold);
        doc.addFont('Montserrat-Bold-bold.ttf', 'Montserrat-Bold', 'normal');




        let header = function () {
          doc.setFontSize(20);
          doc.setFontStyle('bold');
          doc.addImage(img, 'png', 14, 7, 80, 22);
          doc.text(datapdf.title, 100, 20);
        };


        let styles = {
          cellPadding: 2,
          font: 'Montserrat-Regular',
          fontSize: 8,
          valign: 'middle',
          overflow: 'linebreak',
          tableWidth: 'auto',
          lineColor: 'black',
          textColor: 'black',
          halign: 'left',
          fillColor: '#fff'
        };

        doc.autoTable({
          body: datapdf.data1,
          styles: styles,
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold' },
            1: {font: 'Montserrat-Regular' },
            2: {cellWidth: 30, font: 'Montserrat-Bold' },
            3: {font: 'Montserrat-Regular' },
          },
          theme: 'grid',
          margin: {top: 30},
          beforePageContent: header
        });

        styles.halign ='center';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2aheader,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 60, font: 'Montserrat-Bold' },
            1: {cellWidth: 60, font: 'Montserrat-Bold' },
            2: {font: 'Montserrat-Bold' },
          },
        });

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2a,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 60, font: 'Montserrat-Regular' },
            1: {cellWidth: 60, font: 'Montserrat-Regular' },
            2: { font: 'Montserrat-Regular' },
          },
        });
        styles.halign ='left';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2b,
          styles: styles,
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold'},
            1: {font: 'Montserrat-Bold' }
          },
          theme: 'grid',
        });

        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2b1,
          styles: styles,
          tableLineWidth: 0.3,
          tableLineColor: '#555',
          columnStyles: {
            0: {cellWidth: 8, halign: 'right', font: 'Montserrat-Bold', textColor: '#d10d0d', lineWidth: 0},
            1: {cellWidth: 32, font: 'Montserrat-Bold', halign: 'left', lineWidth: 0}
          },
          theme: 'grid',
        });
        styles.fillColor ='#fff';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2b2,
          styles: styles,
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold' }
          },
          theme: 'grid',
        });

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data8,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold' }
          }
        });
        styles.halign ='center';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data5,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: { font: 'Montserrat-Bold' }
          },
        });
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data6,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 50, font: 'Montserrat-Bold'},
            1: {cellWidth: 50, font: 'Montserrat-Bold'},
            2: {cellWidth: 40, font: 'Montserrat-Bold'},
            3: {font: 'Montserrat-Bold'},
          },
        });
        styles.halign ='left';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data7,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 50, font: 'Montserrat-Regular' },
            1: {cellWidth: 50, font: 'Montserrat-Regular' },
            2: {cellWidth: 40, font: 'Montserrat-Regular' },
          },
        });


        ///////////

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data2c,
          styles: styles,
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold' }
          },
          theme: 'grid',
        });

        styles.fillColor ='#eee';
        styles.halign ='center';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data3,
          styles: styles,
          theme: 'grid',
        });
        styles.halign ='left';
        styles.fillColor ='#fff';


        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data4,
          styles: styles,
          columnStyles: {
            0: {cellWidth: 40, font: 'Montserrat-Bold' }
          },
          theme: 'grid',
        });

        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data4b,
          styles: styles,
          tableLineWidth: 0.3,
          tableLineColor: '#555',
          columnStyles: {
            0: {cellWidth: 8, halign: 'right', font: 'Montserrat-Bold', textColor: '#d10d0d', lineWidth: 0},
            1: {cellWidth: 32, font: 'Montserrat-Bold', halign: 'left', lineWidth: 0}
          },
          theme: 'grid',
        });
        styles.fillColor ='#fff';


        styles.halign ='center';
        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data9,
          styles: styles,
          theme: 'grid',
          tableLineWidth: 0.3,
          tableLineColor: '#555',
          columnStyles: {
            0: {cellWidth: 50, halign: 'right', font: 'Montserrat-Bold', textColor: '#d10d0d', lineWidth: 0},
            1: {font: 'Montserrat-Bold', halign: 'left', lineWidth: 0}
          },
        });
        styles.halign ='left';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data10,
          styles: styles,
          theme: 'grid',
        });
         styles.fillColor ='#fff';


        styles.halign ='center';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data11,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 30, font: 'Montserrat-Bold'},
            1: {cellWidth: 30, font: 'Montserrat-Bold'},
            2: {cellWidth: 30, font: 'Montserrat-Bold'},
            3: {cellWidth: 30, font: 'Montserrat-Bold'},
            4: {cellWidth: 30, font: 'Montserrat-Bold'},
            5: {font: 'Montserrat-Bold'},
          },
        });
        styles.halign ='left';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data12,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            0: {cellWidth: 30, font: 'Montserrat-Regular'},
            1: {cellWidth: 30, font: 'Montserrat-Regular'},
            2: {cellWidth: 30, font: 'Montserrat-Regular'},
            3: {cellWidth: 30, font: 'Montserrat-Regular'},
            4: {cellWidth: 30, font: 'Montserrat-Regular'},
          },
        });

        styles.fillColor ='#eee';
        styles.halign ='center';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data13,
          styles: styles,
          theme: 'grid',
          columnStyles: {
              0: {font: 'Montserrat-Bold'},
              1: {font: 'Montserrat-Bold'},
              2: {font: 'Montserrat-Bold'},
              3: {font: 'Montserrat-Bold'},
              4: {font: 'Montserrat-Bold'},
          },
        });

        styles.fillColor ='#fff';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data13space,
          styles: styles,
          theme: 'grid',
        });
        styles.fillColor ='#eee';


        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data13a,
          styles: styles,
          theme: 'grid',
          tableLineWidth: 0.3,
          tableLineColor: '#555',
          columnStyles: {
            0: {cellWidth: 10, halign: 'right', font: 'Montserrat-Bold', textColor: '#d10d0d', lineWidth: 0},
            1: { halign: 'left', lineWidth: 0, font: 'Montserrat-Regular' }
          },
        });
        // doc.autoTable({
        //   startY: doc.autoTableEndPosY() ,
        //   body: datapdf.data13b,
        //   styles: styles,
        //   theme: 'grid',
        // });
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data13c,
          styles: styles,
          theme: 'grid',
          columnStyles: {
              0: { font: 'Montserrat-Bold' },
          },
        });
        styles.halign ='left';
        styles.fillColor ='#fff';


        // if(this.statusepilection == 'si' || this.statusepilection == 'yes'){
          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data14a,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {cellWidth: 8, font: 'Montserrat-Bold', halign: 'right', fillColor: '#eee', textColor: '#d10d0d'},
              1: {cellWidth: 26, font: 'Montserrat-Bold', fillColor: '#eee'},
              2: {cellWidth: 8, font: 'Montserrat-Bold', halign: 'right', fillColor: '#eee', textColor: '#d10d0d'},
              3: {cellWidth: 30, font: 'Montserrat-Bold', fillColor: '#eee'},
            },
          });

          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data14,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {cellWidth: 22, fillColor: '#eee', cellPadding: 1, font: 'Montserrat-Regular' },
              1: {cellWidth: 12, fillColor: '#eee', cellPadding: 1, font: 'Montserrat-Regular' },
              2: {cellWidth: 38, fillColor: '#eee', font: 'Montserrat-Regular' },
              3: {cellPadding: 5, font: 'Montserrat-Regular' },
            },
          });
          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data14b,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {fillColor: '#eee', font: 'Montserrat-Bold'},
            },
          });
          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data14b1,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {fillColor: '#eee', font: 'Montserrat-Bold'},
            },
          });

          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data14b2,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {fillColor: '#eee', font: 'Montserrat-Bold'},
            },
          });
        // }

        // if(this.statusemergencyepilection == 'yes' || this.statusemergencyepilection == 'si' ){
          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data15,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {cellWidth: 30, font: 'Montserrat-Bold' },
              1: {font: 'Montserrat-Regular'},
              2: {cellWidth: 20, font: 'Montserrat-Bold' },
              3: { font: 'Montserrat-Regular' },
            },
          });
          doc.autoTable({
            startY: doc.autoTableEndPosY() ,
            body: datapdf.data15a,
            styles: styles,
            theme: 'grid',
            columnStyles: {
              0: {cellWidth: 30, font: 'Montserrat-Bold' },
              1: {font: 'Montserrat-Regular' }
            },
          });
        // }

        styles.halign = 'center';
        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16a,
          styles: styles,
          theme: 'grid',
        });
        styles.fillColor ='#fff';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16b,
          styles: styles,
          theme: 'grid',
        });

        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16c,
          styles: styles,
          theme: 'grid',
        });

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16d,
          styles: styles,
          theme: 'grid',
          tableLineWidth: 0.3,
          tableLineColor: '#555',
          columnStyles: {
            0: {cellWidth: 45, halign: 'right', font: 'Montserrat-Bold', textColor: '#d10d0d', lineWidth: 0},
            1: { halign: 'left', lineWidth: 0, font: 'Montserrat-Regular' }
          },
        });
        styles.fillColor ='#fff';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16e,
          styles: styles,
          theme: 'grid',
        });

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16f,
          styles: styles,
          theme: 'grid',
        });


        styles.fillColor ='#eee';
        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data16g,
          styles: styles,
          theme: 'grid',
        });
        styles.fillColor ='#fff';

        doc.autoTable({
          startY: doc.autoTableEndPosY() ,
          body: datapdf.data17,
          styles: styles,
          theme: 'grid',
          columnStyles: {
            1: {cellWidth: 60, cellPadding: 8, font: 'Montserrat-Regular' },
          },
        });
        styles.halign = 'left'

        doc.save(pdfName + '.pdf');
      } else {
        return false
      }
    },
    validate: function(){
      if(
        this.date &&
        this.name &&
        this.surname &&
        this.birthdate &&
        this.gender &&
        this.uniqueid &&
        this.caregiversname &&
        this.caregiversphone &&
        this.caregiversemail &&
        this.pediatricname &&
        this.pediatricphone &&
        this.pediatricemail &&
        this.specialistname &&
        this.specialistinstitution &&
        this.specialistphone &&
        this.specialistemail &&
        this.diseasename &&
        this.diseasesummary1 &&
        this.diseasesummary2link &&
        this.diseasesummary3 &&
        this.sideeffect &&
        this.allergies &&
        this.patientweight &&
        this.patientheight &&
        this.drugsinteractions &&
        this.seizures &&
        this.treatments &&
        this.feveradaptprotocol &&
        this.statusepilection &&
        this.emergencyepilection &&
        this.statusemergencyepilection &&
        this.statusemergencytrat2
      ){
        return true;
      } else {
        return false;
      }
    }
  }

}
</script>
<style>
p{
  padding: 5px;
  background-color: #eee;
}
.leng{
  font-size: 1.2em;
  position: absolute;
  /*display: inline-block;*/
  display: block;
  top: 1em;
  right: 1em;
  z-index: 1000;
  cursor: pointer;
  border: 1px solid #4a5379;
  background-color: #4a5379;
  color: #fff;
  width: auto; /* 36px */
  height: 32px;
  text-align: center;
}
.leng span{
  padding: 0 3px;
  border-left: 1px solid #fff;
  width: 36px;
  display: inline-block;
}
.leng span:first-child {
  border-left: none;
}
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 0px;
}
td textarea{
  margin: 0px !important;
}

th{
  padding: 8;
  text-align: center;
}

.note{
  width: 100%;
}

.input-icons i {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
}

.icon {
  padding: 5px;
  min-width: 50px;
  text-align: center;
}

.input-field {
  width: 100%;
  padding: 5px;
  text-align: center;
}

@media screen and (max-width: 991px){
  .image {
      width: 90%;
  }
  .leng{
    font-size: 1.2em;
    top: 0.7em;
    right: 0.7em;
  }
}
@media screen and (max-width: 600px){
  .image {
      width: 90%;
  }
  .leng{
    font-size: 1em;
    top: 0.7em;
    right: 0.7em;
  }
}
</style>
